import { render, staticRenderFns } from "./selectCodeBalloon.vue?vue&type=template&id=871d61d8&"
import script from "./selectCodeBalloon.vue?vue&type=script&lang=ts&"
export * from "./selectCodeBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./selectCodeBalloon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports